<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      :persistent='true'
      width="50%"
      height="100%"
      class="modalDialog"
      no-click-animation
    >
      <CardTitle :title="pageTitle" />
      <v-card-actions class="cardWrap__scroll">
        <v-container>
          <v-form
            class="cardWrap__fromArea"
            ref="form" v-model="valid"
          >
            <v-row justify="space-around" class="formHeight">
              <div class="cardWrap__fromArea__title">税種別</div>
                <v-select
                  class="mr-3 pt-4"
                  :items="taxType"
                  item-value="code"
                  item-text="code_name"
                  v-model="fromSetData.tax_id"
                  @input="GetSelectTaxLatestDate"
                  validate-on-blur
                  :rules="[actionrules.checkEmpty]"
                ></v-select>
            </v-row>
            <v-row justify="space-around" class="formHeight">
              <div class="cardWrap__fromArea__title">開始日</div>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromSetData.start_date"
                    inputmode="tel"
                    readonly
                    v-on="on"
                    @keydown.tab.exact="menu = false"
                    :rules="[actionrules.checkEmpty]"
                    required
                  />
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="fromSetData.start_date"
                  locale="jp-ja"
                  :day-format="date => new Date(date).getDate()"
                  @input="menu = false"
                />
              </v-menu>
            </v-row>
            <v-row justify="space-around" class="formHeight">
              <div class="cardWrap__fromArea__title">区分</div>
                <v-select
                  class="mr-3 pt-4"
                  :items="taxDivision"
                  item-value="code"
                  item-text="name"
                  v-model="fromSetData.tax_division"
                  validate-on-blur
                  :rules="[actionrules.checkEmpty]"
                ></v-select>
            </v-row>
            <v-row v-if="fromType == true" justify="space-around" class="formHeight">
              <div class="cardWrap__fromArea__title">税</div>
                <v-text-field
                  v-model="fromSetData.tax"
                  inputmode="tel"
                  maxlength="7"
                  validate-on-blur
                  :rules="[actionrules.checkEmpty,
                           actionrules.taxInput,
                           actionrules.taxMax]"
                />
                <v-col class="align-self-center">
                    ％
                </v-col>
            </v-row>
            <v-row v-else justify="space-around" class="formHeight">
              <div class="cardWrap__fromArea__title">税</div>
                <v-text-field
                  v-model="fromSetData.tax"
                  inputmode="tel"
                  maxlength="7"
                  validate-on-blur
                  v-on:focus="fromSetData.tax = formatFoucsFee(fromSetData.tax)"
                  v-on:blur="fromSetData.tax = formatBlurFee(fromSetData.tax)"
                  :rules="[actionrules.checkEmpty,
                           actionrules.correctFee]"
                />
                <v-col class="align-self-center">
                    円
                </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
        <v-btn color="green darken-4" text v-if="addModeStatus" @click="RegistTax">登録</v-btn>
        <v-btn color="green darken-4" text v-if="changeModeStatus" @click="UpdateTax">変更</v-btn>
      </v-card-actions>
      <ChangeOverlay
        page-name="税"
        @cancel="CloseModal"
        :process-result="process"
        :OverlaySwitch="changeOverlay"
      />
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import validater from '../../../../lib/validater';
import ChangeOverlay from '@/components/overlay/ChangeOverlay';
import { utilityMixin } from '@/mixins/utility';
import { CODE_MASTER } from '../../../config';
import { UPDATE_TAX_MASTER, REGISTER_TAX_MASTER, GET_SELECT_TAX_LATEST_DATE } from '@/constants/tax';

export default {
    components: {
        CardTitle,
        ChangeOverlay
    },
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            pageTitle: null,
            dialog: false,
            changeModeStatus: false,
            addModeStatus: false,
            taxDivision: null,
            latestStartDate: '0',
            GolfCourseList: [],
            taxType: [],
            menu: false,
            valid: false,
            fromType: false,
            changeOverlay: false,
            actionrules: {
                CorrectDate: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct'),
                limit: value => this.LimitDateCheck(value) || this.latestStartDate + '以降の日付にしてください',
                taxInput: value => /^([1-9]\d*|0)(\.\d+)?$/.test(value) || this.$t('error.validation.required.incorrect'),
                checkEmpty: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any'),
                taxMax: value => this.PercentComparisonCheck(value) || '%の場合200以下で設定してください',
                correctFee: value => validater.checkFeeType(value) || this.$t('error.validation.required.incorrect')
            },
            fromSetData: {
                id: null,
                valid_flag: null,
                start_date: null,
                tax_division: null,
                tax_id: null,
                tax: null,
                golf_code: null,
                golf_group_code: null,
                oldTaxId: null,
                oldStartDate: null
            },
            // 処理結果
            process: {
                result: '',
                resultText: '',
                textFlag: false
            }
        };
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.addModeStatus = false;
            this.changeModeStatus = false;
            this.addOverlay = false;
            this.changeOverlay = false;
            this.valid = false;
            this.fromSetData = {
                id: '',
                valid_flag: '',
                start_date: '',
                tax_division: '',
                tax_id: '',
                tax: '',
                golf_code: '',
                golf_group_code: '',
                oldTaxId: '',
                oldStartDate: ''
            };
        },
        /** ----------------------------------------------
         * 変更
         * ---------------------------------------------- */
        UpdateTax: async function () {
            if (this.$refs.form.validate()) {
                try {
                    if (this.fromSetData.tax_id === CODE_MASTER.TAX_TYPE_CONSUMPTION) {
                        this.fromSetData.golf_code = CODE_MASTER.AUTHORITY_SYSTEM_ADMIN_GOLF_CODE;
                    }
                    let name = this.taxType.find(data => data.code === this.fromSetData.tax_id);
                    await this.$apollo.mutate({
                        mutation: UPDATE_TAX_MASTER,
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.fromSetData.golf_code,
                            tax_id: this.fromSetData.tax_id,
                            start_date: this.fromSetData.start_date,
                            tax_name: name.code_name,
                            tax_division: this.fromSetData.tax_division,
                            tax: this.fromSetData.tax.replace(/,/g, ''),
                            old_tax_id: this.fromSetData.oldTaxId,
                            old_start_date: this.fromSetData.oldStartDate,
                            id: this.fromSetData.id
                        }
                    }).then(res => {
                        if (res.data.UpdateTaxMaster.result === 0) {
                            this.changeOverlay = true;
                            this.process.result = 1;
                            this.process.resultText = '既に同じ内容で登録されています。';
                        } else {
                            this.changeOverlay = true;
                            this.process.result = 1;
                            this.process.resultText = '更新が完了しました。再度、プランの料金設定を見直してください。';
                            this.process.textFlag = true;
                        }
                    });
                } catch (error) {
                    this.error = error;
                }
            }
        },
        /** ----------------------------------------------
         * 選択された税種別の最新の日付を調べる
         * ---------------------------------------------- */
        GetSelectTaxLatestDate: async function () {
            try {
                await this.$apollo.mutate({
                    mutation: GET_SELECT_TAX_LATEST_DATE,
                    variables: {
                        golf_group_code: process.env.VUE_APP_GROUP_CODE,
                        golf_code: this.fromSetData.golf_code,
                        tax_id: this.fromSetData.tax_id
                    }
                }).then(res => {
                    this.latestStartDate = res.data.GetSelectTaxLatestDate.latest_start_date;
                });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * 追加
         * ---------------------------------------------- */
        RegistTax: async function () {
            if (this.$refs.form.validate()) {
                try {
                    if (this.fromSetData.tax_id === CODE_MASTER.TAX_TYPE_CONSUMPTION) {
                        this.fromSetData.golf_code = CODE_MASTER.AUTHORITY_SYSTEM_ADMIN_GOLF_CODE;
                    }
                    let name = this.taxType.find(data => data.code === this.fromSetData.tax_id);
                    await this.$apollo.mutate({
                        mutation: REGISTER_TAX_MASTER,
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.fromSetData.golf_code,
                            tax_id: this.fromSetData.tax_id,
                            start_date: this.fromSetData.start_date,
                            tax_name: name.code_name,
                            tax_division: this.fromSetData.tax_division,
                            tax: this.fromSetData.tax.replace(/,/g, '')
                        }
                    }).then(res => {
                        if (res.data.RegisterTaxMaster.result === 0) {
                            this.changeOverlay = true;
                            this.process.result = 1;
                            this.process.resultText = '既に同じ内容で登録されています。';
                        } else {
                            this.dialog = false;
                            this.$refs.form.resetValidation();
                            this.$emit('from-Dialog');
                        }
                    });
                } catch (error) {
                    this.error = error;
                }
            }
        },
        /** ----------------------------------------------
         * パーセントの場合200%以下になっているか
         * ---------------------------------------------- */
        PercentComparisonCheck (value) {
            if (this.fromSetData.tax_division === Number(CODE_MASTER.TAX_DIVISION_PERCENT) && value > 200) {
                return false;
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
         * 登録時、同じ税種別の開始日が過去の開始日より過去になっていないか
         * ---------------------------------------------- */
        LimitDateCheck (value) {
            var inputDate = null;
            var latestStartDate = null;
            if (value) {
                inputDate = Number(value.replace(/-/g, ''));
            }
            if (!this.latestStartDate) {
                this.latestStartDate = '00000000';
            } else if (this.latestStartDate) {
                latestStartDate = Number(this.latestStartDate.replace(/-/g, ''));
            }
            if (inputDate >= latestStartDate) {
                return true;
            } else if (!latestStartDate) {
                return false;
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 現在日付の取得
         * ---------------------------------------------- */
        GetDateNow () {
            var nowDate = new Date();
            nowDate.setDate(nowDate.getDate());
            this.fromSetData.start_date = nowDate.getFullYear() + '-' + ('0' + (nowDate.getMonth() + 1)).slice(-2) + '-' + ('0' + nowDate.getDate()).slice(-2);
        },
        /** ----------------------------------------------
         * 親画面にて「追加」ボタン押下時の処理
         * ---------------------------------------------- */
        AddModal (GolfCourseList, taxType, userDiv, taxId) {
            this.Initialize();
            userDiv = String(userDiv);
            // ゴルフ場担当者だったら
            if (userDiv === CODE_MASTER.AUTHORITY_GOLFCOUSE_ADMIN) {
                for (var i = 0; i < taxType.length; i++) {
                    if (taxType[i].reserve1 === '2') {
                        this.taxType.push(taxType[i]);
                    }
                }
            // システム管理者だったら
            } else {
                this.taxType = taxType;
            }
            if (taxId === CODE_MASTER.TAX_TYPE_CONSUMPTION) {
                this.taxDivision = [{ code: 1, name: '%' }];
                this.fromSetData.tax_division = 1;
                this.fromType = true;
            } else {
                this.taxDivision = [{ code: 2, name: '円' }];
                this.fromSetData.tax_division = 2;
                this.fromType = false;
            }
            this.GetDateNow();
            this.fromSetData.tax_id = taxId;
            this.fromSetData.golf_code = GolfCourseList;
            this.pageTitle = '税登録';
            this.dialog = true;
            this.addModeStatus = true;
            this.GetSelectTaxLatestDate();
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        EditModal (Item, taxType, userDiv, taxId) {
            this.Initialize();
            userDiv = String(userDiv);
            // ゴルフ場担当者だったら
            if (userDiv === CODE_MASTER.AUTHORITY_GOLFCOUSE_ADMIN) {
                for (var i = 0; i < taxType.length; i++) {
                    if (taxType[i].reserve1 === '2') {
                        this.taxType.push(taxType[i]);
                    }
                }
            // システム管理者だったら
            } else {
                this.taxType = taxType;
            }
            if (Item.tax_id === CODE_MASTER.TAX_TYPE_CONSUMPTION) {
                this.taxDivision = [{ code: 1, name: '%' }];
                this.fromType = true;
            } else {
                this.taxDivision = [{ code: 2, name: '円' }];
                this.fromType = false;
            }
            this.pageTitle = '税編集';
            this.fromSetData.id = Item.id;
            this.fromSetData.valid_flag = Item.valid_flag;
            this.fromSetData.start_date = Item.start_date;
            this.fromSetData.tax_division = Item.tax_division;
            this.fromSetData.golf_group_code = Item.golf_group_code;
            this.fromSetData.golf_code = Item.golf_code;
            this.fromSetData.tax = Item.tax;
            this.fromSetData.tax_id = Item.tax_id;
            this.fromSetData.oldTaxId = Item.tax_id;
            this.fromSetData.oldStartDate = Item.start_date;
            this.changeModeStatus = true;
            this.dialog = true;
            this.GetSelectTaxLatestDate();
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.$refs.form.resetValidation();
            this.dialog = false;
            this.latestStartDate = null;
            this.fromSetData = {
                valid_flag: null,
                start_date: null,
                tax_division: null,
                tax_id: null,
                tax: null,
                golf_code: null,
                golf_group_code: null,
                oldTaxId: null,
                oldStartDate: null
            };
            this.$emit('from-Dialog');
            this.Initialize();
        }
    }
};
</script>

<style scoped>

.formHeight{
  max-height: 60px;
  max-width: 100%;
}

</style>
